import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private toaster: ToastrService) {}

  publishMessages(content: string, state: string): void {
    state === 'success' ? this.displaySuccess(content, 'Success') : this.displayError(content, 'Error');
  }

  displaySuccess(message: string, title?: string) {
    this.toaster.success(message, title);
  }

  displayError(message: string, title?: string) {
    this.toaster.error(message, title);
  }
}
